<template>
	<div class="creatOrder layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="setClass(1)" v-if="showClass!=1" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i> {{showClass==1?'材料管理':'消耗明细'}}
			</div>
		</div>
		<div v-show="showClass==1" style="width: 90%;margin: 0 auto;">
			<button @click="setClass(2)" type="button" class="layui-btn zt_color" style="margin:20px 0 0;">材料消耗明细</button>
			<div>
				<div class="zt_color" style="padding:8px 30px;color:#fff;margin-top:20px;">剩余材料</div>
				<table class="layui-table align_center" style="margin: 20px auto;" lay-size="sm" lay-skin=''>
					<thead>
						<tr>
							<th class="align_center">材料名称</th>
							<th class="align_center">钢片厚度</th>
							<th class="align_center">剩余数量</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i">
							<td :rowspan="item.count" v-if="i == 0 || item.attr_id != datas[i - 1].attr_id">{{item.mesh_attr_text}}</td>
							<td>{{item.mesh_attr_info_text}}</td>
							<td>{{item.stock}}</td>
						</tr>
					</tbody>
				</table>
				<div v-if="ts == 1" style="margin-bottom: 10px;color: red;">*提示: 材料不足，请及时联系客服补充材料</div>
			</div>
			<div class="zt_color" style="padding:8px 30px;color:#fff;">领料记录</div>
			<table class="layui-table align_center" lay-skin='line' lay-even lay-size="sm">
				<colgroup>
					<col width="100">
					<col>
				</colgroup>
				<thead>
					<tr>
						<th class="align_center">序号</th>
						<th class="align_center">物料规格（规格/厚度/数量）</th>
						<th class="align_center">发货时间</th>
						<th class="align_center">领料时间</th>
						<th class="align_center">快递公司</th>
						<th class="align_center">快递单号</th>
						<th class="align_center">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas1" :key="i">
						<td>{{i + 1}}</td>
						<td>
							<div v-for="(l,j) in item.num" :key="j">{{l.attr_title}} / {{l.attr_info_title}} / {{l.materials_num}}</div>
						</td>
						<td>{{item.times}}</td>
						<td>{{item.times2 ? item.times2 : ''}}</td>
						<td>{{item.express_name}}</td>
						<td>{{item.express_num}}</td>
						<td>
							<button type="button" @click="showDetail(item,i)" style="width:92px;" :class="'layui-btn pointer ' + (item.status == 1? 'zt_color':'layui-bg-gray')">{{item.status==1?'确认收货':'已收货'}}</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div id="lypages2"></div>
		</div>
		<!-- 消耗 -->
		<div v-show="showClass==2">
			<div class="sxBox" style="width: 90%; margin: 20px 5%;">
				<div class="layui-form f_row al_itm">
					<div class="layui-input-inline">
						<input type="text" class="layui-input" v-model="materialtext" placeholder="材料名称">
					</div>
					<button type="button" class="layui-btn zt_color margin_l20" @click="onSearch">搜索</button>
				</div>
			</div>
			<table class="layui-table align_center" style="width: 90%; margin: 0px 5%;" lay-even>
				<thead>
					<tr>
						<th class="align_center">订单编号</th>
						<th class="align_center">材料名称</th>
						<th class="align_center">厚度</th>
						<th class="align_center">创建时间</th>
						<th class="align_center">消耗数量</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas2" :key="i">
						<td>{{item.order_num}}</td>
						<td>{{item.material_name}}</td>
						<td>{{item.material_attr_name}}</td>
						<td>{{item.times}}</td>
						<td>{{item.num}}</td>
					</tr>
					<tr v-if="datas2 == [] || datas2.length == 0">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="5">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<div id="lypages" style="margin-left: 5%;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'creatOrder',
		data() {
			return {
				dscModel: false,
				showClass: 1,
				tables: '',
				laypage: '',
				datas: [],
				datas1: [],
				datas2: [],
				pages: 1,
				pages2: 1,
				limit: 10,
				count: 1,
				count2: 1,
				ts: 0,
				materialtext: '',
				search: 0
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			let _this = this;
			layui.use(['table', 'laypage'], () => {
				this.tables = layui.table;
			});
		},
		methods: {
			getData() {
				let _this = this;
				//材料信息
				api.getMaterialInfo({
					token: _this.getCookie('token'),
				}).then((res) => {
					if(res.code == 1) {
						_this.datas = res.data;
						for(let i = 0; i < res.data.length; i++) {
							if(res.data[i].stock < 500) {
								_this.ts = 1
							}
						}
					}
				});
				//材料明细--领料
				api.getMaterialLog({
					token: _this.getCookie('token'),
					type: 2,
					page: _this.pages2,
					limit: _this.limit,
					keyword: _this.materialtext
				}).then((res) => {
					console.log(res);
					if(res.code == 1) {
						_this.datas1 = res.data.list;
						for(let i in _this.datas1) {
							_this.datas1[i].times = this.getTimes(_this.datas1[i].createtime)
							_this.datas1[i].times2 = this.getTimes(_this.datas1[i].updatetime)
						}
					}
					layui.use(['laypage'], () => {
						let laypage = layui.laypage;
						laypage.render({
							elem: 'lypages2', //注意，这里的 lypages 是 ID，不用加 # 号
							theme: '#4876FF',
							count: _this.count2,
							limit: 10,
							jump: function(obj, first) {
								if(!first) {
									_this.pages2 = obj.curr;
									_this.getData2();
								}
							}
						});
					});
				})
			},
			getData2() {
				let _this = this;
				api.getMaterialLog({
					token: _this.getCookie('token'),
					type: 2,
					page: _this.pages2,
					limit: _this.limit,
					keyword: _this.materialtext
				}).then((res) => {
					if(res.code == 1) {
						_this.datas1 = res.data.list;
						for(let i in _this.datas1) {
							_this.datas1[i].times = this.getTimes(_this.datas1[i].createtime)
							_this.datas1[i].times2 = this.getTimes(_this.datas1[i].updatetime)
						}
					}
				})
			},
			showDetail(item, i) { // 收货
				if(item.status == 1) {
					let _this = this
					let m_ids = []
					for(let i = 0; i < _this.datas.length; i++) {
						m_ids.push(this.datas[i].id);
					}
					m_ids = m_ids.join(',');
					layui.use(['layer'], () => {
						layer.open({
							title: '提示',
							content: '请确认收到货物',
							btn: ['确定', '取消'],
							closeBtn: 0,
							yes: function(index, layero) {
								api.confirmLog({
									token: _this.getCookie('token'),
									log_id: item.id,
									m_ids: m_ids
								}).then((res) => {
									console.log(res)
									if(res.code == 1) {
										_this.datas1[i].status = !_this.datas1[i].status;
										api.getMaterialInfo({ //材料信息
											token: _this.getCookie('token'),
										}).then((res) => {
											if(res.code == 1) {
												layer.closeAll();
												_this.datas = res.data;
												for(let i = 0; i < res.data.length; i++) {
													if(res.data[i].stock < 500) {
														_this.ts = 1
													}
												}
											} else {
												layer.msg(res.msg, {
													icon: 2,
													anim: 6
												})
											}

										})
									}
								})
							},
							btn2: function(index, layero) {}
						})

					})
				}
			},
			onSearch() {
				this.pages = 1;
				this.search = 1;
				this.count = 1;
				this.getScoreLogData();
			},
			getScoreLogData() {
				let _this = this
				layui.use(['laypage'], () => {
					let laypage = layui.laypage;
					api.getMaterialLog({ //材料明细--消耗
						token: _this.getCookie('token'),
						type: 1,
						page: _this.pages,
						limit: _this.limit,
						keyword: _this.materialtext
					}).then((res) => {
						if(res.code == 1) {
							for(let i in res.data.list) {
								res.data.list[i].times = this.getTimes(res.data.list[i].createtime)
							};
							_this.datas2 = res.data.list;
							_this.count = res.data.count;
						} else {
							_this.datas2 = [];
						}
						laypage.render({
							elem: 'lypages', //注意，这里的 lypages 是 ID，不用加 # 号
							theme: '#4876FF',
							count: _this.count,
							limit: 10,
							jump: function(obj, first) {
								if(!first) {
									_this.pages = obj.curr;
									_this.getScoreLogData2();
								}
							}
						});
					})
				})
			},
			getScoreLogData2() {
				let _this = this
				layui.use(['laypage'], () => {
					let laypage = layui.laypage;
					api.getMaterialLog({ //材料明细--消耗
						token: _this.getCookie('token'),
						type: 1,
						page: _this.pages,
						limit: 10,
						keyword: _this.materialtext
					}).then((res) => {
						if(res.code == 1) {
							_this.datas2 = res.data.list;
							for(let i in _this.datas2) {
								_this.datas2[i].times = this.getTimes(_this.datas2[i].createtime)
								// _this.datas2[i].num
							}
						}
					})
				})
			},
			setClass(e) {
				let _this = this
				this.showClass = e;
				if(e == 2) {
					_this.getScoreLogData()
				}
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.creatOrder {
		font-family: SourceHanSansSC;
	}
</style>


// WEBPACK FOOTER //
// src/components/materMent.vue